<template>
  <!-- 后续将移出 作为PgTree使用 -->
  <div class="flex flex-v pg-tree">
    <div class="flex-shrink pg-tree_top" v-if="data.length > 0">
      <PgInput
        class="pg-tree_top-input"
        placeholder="输入关键字进行过滤"
        @change="filterChange"
        v-model="filterValue"
        clearable
        prefix-icon="el-icon-search"
      >
      </PgInput>
      <el-button type="text" class="pg-tree_top-btn" @click="beforeExpand">{{
        expandStatus ? '全部收起' : '全部展开'
      }}</el-button>
    </div>
    <Tree
      class="pg-tree_content"
      v-if="data.length > 0"
      :data="treeData"
      v-bind="treeProps"
      :filter-node-method="filterNode"
      ref="treeRef"
      :default-expanded-keys="defaultExpendKeys"
      v-on="$listeners"
    >
      <template #default="{ node, data }">
        <span>
          <i class="ivu-icon-icon-pg-yjfl" v-if="!data.lead || data.lead == '0'"></i>
          <i v-else class="ivu-icon-icon-pg-ejfl"></i>
          <slot :data="data" :node="node">
            <span
              :class="{
                'custom-tree-node--active':
                  currentNode?.[treeProps.nodeKey] === data[treeProps.nodeKey],
                'custom-tree-node': treeProps['highlightCurrent'],
              }"
            >
              <label
                v-if="treeProps.props.subLabel && getValueByPath(data, treeProps.props.subLabel)"
                >({{ getValueByPath(data, treeProps.props.subLabel) }})</label
              >
              {{ getValueByPath(data, treeProps.props.label) }}
            </span>
          </slot>
        </span>
      </template>
    </Tree>
    <PgEmpty v-else></PgEmpty>
  </div>
</template>
<script setup>
// vue
import { ref, computed } from 'vue'

// components
import { Tree } from 'element-ui'
import { PgEmpty } from '../../empty/index'

// utils
import { getValueByPath, getTreeExpandList, setValueByPath } from '../../../utils/index'

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  treeDefaultProps: Object,
  filterKeys: {
    type: Array,
    default: () => ['name'],
  },
  parentNode: {
    type: Object,
    default: () => null,
  },
  defaultExpendKeys: {
    type: Array,
    default: () => [],
  },
  currentNode: Object,
})

// -------------------------------基础数据初始化--------------------------------------

// treeRef
const treeRef = ref(null)
// treeProps
const treeProps = computed(() => {
  return Object.assign(
    {},
    {
      nodeKey: 'id', // 每个树节点用来作为唯一标识的属性，整棵树应该是唯一的
      highlightCurrent: false, // 是否高亮当前选中节点，默认值是 false。
      expandOnClickNode: false, // 是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点。
      defaultExpandAll: false, // 是否默认展开所有节点
      props: {
        label: 'name',
        children: 'children', // 指定子树为节点对象的某个属性值
        subLabel: 'code',
      },
    },
    props.treeDefaultProps
  )
})

// 数据-监听处理
const treeData = computed(() => {
  if (props.parentNode) {
    const childrenKey = treeProps.value.props.children
    const tempObj = {
      ...props.parentNode,
    }
    setValueByPath(tempObj, childrenKey, props.data)
    return [tempObj]
  } else {
    return props.data
  }
})

// 当前树 的展开状态
const expandStatus = ref(treeProps.value.defaultExpandAll)

// 记录当前树的nodeKey组成的数组
const treeNodeExpandArray = computed(() => getTreeExpandList(props.data))
const treeNodeKeyArray = computed(() => {
  return treeNodeExpandArray.value.map((im) => getValueByPath(im, treeProps.value.nodeKey))
})

// 默认展开的节点的 key 的数组
const defaultExpendKeys = ref(props.defaultExpendKeys)

// -------------------------------树过滤相关--------------------------------------

// 过滤输入框中输入数据后 按回车，将调用树的过滤方法
const filterValue = ref(null)
const filterChange = (value) => {
  treeRef.value.filter(value)
}

// 过滤数据
const filterNode = (value, data) => {
  if (!value) return data
  return props.filterKeys.find(
    (im) => getValueByPath(data, im) && getValueByPath(data, im).indexOf(value) > -1
  )
}

// -------------------------------树收起展开处理--------------------------------------

// 展开收起方法 true:全部展开 false:全部收起
const beforeExpand = () => {
  expandStatus.value = !expandStatus.value
  expandFunc(treeData.value, expandStatus.value)
}

// 遍历树形数据，通过设置每一项的expanded属性，实现展开与折叠
const expandFunc = (data, status) => {
  data.forEach((item) => {
    treeRef.value.store.nodesMap[getValueByPath(item, treeProps.value.nodeKey)].expanded = status
    if (
      getValueByPath(item, treeProps.value.props.children) != null &&
      getValueByPath(item, treeProps.value.props.children).length > 0
    ) {
      expandFunc(getValueByPath(item, treeProps.value.props.children), status)
    }
  })
}

// -------------------------------初始化--------------------------------------

// 初始化处理一些 数据
const init = () => {
  // 处理默认展开情况
  if (expandStatus.value) {
    defaultExpendKeys.value = treeNodeKeyArray.value
  }
  // 清空过滤数据
  filterValue.value = null
}

init()
</script>
<style lang="scss">
@import '../style/tree.scss';
</style>
